import React from 'react';
import { Helmet } from 'react-helmet';
import Hero from '../components/programs/Hero';
import Why from '../components/programs/Why';
import Programs from '../components/programs/Programs';
import Faq from '../components/programs/Faq';

const ProgramsPage = () => {

    return (
        <div className="bg-black text-white min-h-screen">
            <Helmet>
                <title>AI Training Programs for Professionals & Teams | Frost & Grey</title>

                <meta
                    name="description"
                    content="Explore Frost & Grey’s AI training programs designed for professionals, teams, and enterprises. Learn practical AI skills, automation tools, and workflow optimization tailored to African organizations."
                />

                <link rel="canonical" href="https://frostandgrey.com/programs" />

                <meta property="og:title" content="AI Training Programs | Frost & Grey" />
                <meta property="og:description" content="Corporate AI training, productivity workflows, and hands-on upskilling programs for modern African professionals and organizations." />
                <meta property="og:url" content="https://frostandgrey.com/programs" />
                <meta property="og:type" content="website" />
            </Helmet>
            <Hero />
            <Why />            
            <Programs />
            <Faq /> 
        </div>
    );
};

export default ProgramsPage;